import dayjs from 'dayjs';

import type { BordereauType } from '@/types';

export const isBordereauTitrageAFaire = (
  bordereau: BordereauType,
  echeanceArreteDate: string | null | undefined,
): boolean => {
  if (bordereau.identifiantArrete) return false;
  if (!echeanceArreteDate) return false;
  return dayjs(bordereau.dateRemise).isBefore(dayjs(echeanceArreteDate), 'day');
};
